class VideoPlayer {
  constructor(element) {
    this.element = element;
    this.preview = this.element.querySelector('[data-element="video-player-preview"]');
    this.button = this.element.querySelector('[data-element="video-player-button"]');
    this.player = this.element.querySelector('[data-element="video-player-player"]');
    this.playerType = this.player.dataset.type;
    this.vimeoPlayer = null;
    this.vimeoVideo = null;
    this.youtubePlayer = null;
    this.youtubeVideo = null;
  }

  init() {
    if ('vimeo' === this.playerType) {
      this.loadVimeoApi();
      this.setupVimeoApi();
    } else if ('youtube' === this.playerType) {
      this.loadYoutubeApi();
      this.setupYoutubeApi();
    }

    this.button.addEventListener('click', this.buttonOnClick.bind(this));
  }

  loadVimeoApi() {
    this.vimeoVideo = this.element.querySelector('[data-element="video-player-vimeo"]');
    const id = 'video-player-vimeo-api';
    const apiScript = document.getElementById(id);

    if ( null !== apiScript ) {
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://player.vimeo.com/api/player.js';
    tag.id = id;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  setupVimeoApi() {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      this.vimeoPlayer = new Vimeo.Player(this.vimeoVideo.id, {
        id: this.vimeoVideo.dataset.id,
      });
    }, 500);
  }

  playVimeo() {
    this.vimeoPlayer.play();
  }

  loadYoutubeApi() {
    this.youtubeVideo = this.element.querySelector('[data-element="video-player-youtube"]');
    const id = 'video-player-youtube-api';
    const apiScript = document.getElementById(id);

    if ( null !== apiScript ) {
      return;
    }

    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.id = id;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  setupYoutubeApi() {
    setTimeout(() => {
      // eslint-disable-next-line no-undef
      this.youtubePlayer = new YT.Player(this.youtubeVideo.id, {
        videoId: this.youtubeVideo.dataset.id,
      });
    }, 500);
  }

  playYoutube() {
    this.youtubePlayer.playVideo();
  }

  buttonOnClick() {
    this.preview.classList.add('video-player__preview--hide');
    this.player.classList.add('video-player__player--show');

    if ('vimeo' === this.playerType) {
      this.playVimeo();
    } else if ('youtube' === this.playerType) {
      this.playYoutube();
    }
  }
}

const videoPlayer = {
  init() {
    const videoPlayerElements = document.querySelectorAll('[data-module="video-player"]');

    if (videoPlayerElements && videoPlayerElements.length) {
      videoPlayerElements.forEach((element) => {
        const videoPlayerElement = new VideoPlayer(element);
        videoPlayerElement.init();
      });
    }
  },
};

export default videoPlayer;
